
<button class="btn btn-lg bg-white float-right" routerLink="./new-invoice-rule"><i class="align-middle  fas fa-plus-circle"></i> Add Invoice Rule</button>
<table class="neu-table table table-striped neu-table w-100" datatable [dtOptions]="dtOptions" data-page="2" ></table>